import { QueryCollection, QueryEngine } from "../mjml-to-amp";

class NativeQueryCollection implements QueryCollection {
  private elements: Element[];

  constructor(elements: Element[]) {
    this.elements = elements;
  }

  remove() {
    this.elements.forEach((el) => el.remove());
  }

  html(newHtml?: string): string | null {
    if (newHtml !== undefined) {
      this.elements.forEach((el) => {
        el.innerHTML = newHtml;
      });
      return null;
    }
    return this.elements[0]?.innerHTML ?? null;
  }

  attr(name: string, value?: string): string | null | undefined {
    if (value !== undefined) {
      this.elements.forEach((el) => {
        el.setAttribute(name, value);
      });
      return null;
    }
    return this.elements[0]?.getAttribute(name);
  }

  removeAttr(name: string) {
    this.elements.forEach((el) => el.removeAttribute(name));
  }

  each(callback: (index: number, element: any) => void) {
    this.elements.forEach((el, index) => callback(index, el));
  }

  append(content: string) {
    this.elements.forEach((el) => {
      el.insertAdjacentHTML("beforeend", content);
    });
  }
}

/**
 * Not entirely sure this actually matches the backend (Cheerio) behavior.
 * It does output valid HTML that passes the vibe check, at least.
 * TODO: verify that AMP blocks render correctly in the email builder.
 */
export class NativeQueryEngine implements QueryEngine {
  private root: Document | Element;

  constructor(root: Document | Element) {
    this.root = root;
  }

  find(selector: string | Element): QueryCollection {
    if (selector instanceof Element) {
      // If the input is already an Element, wrap it in a QueryCollection directly
      return new NativeQueryCollection([selector]);
    }

    // Otherwise, treat it as a CSS selector
    const elements = Array.from(this.root.querySelectorAll(selector));
    return new NativeQueryCollection(elements);
  }

  html(): string | null {
    return this.root instanceof Document
      ? this.root.documentElement.outerHTML
      : this.root.outerHTML;
  }
}
